import { SvgIcon } from "@mui/material"
import React from "react"
import { IconProps } from "./IconType"

const DrawerSupplementalIcon = ({ admin, active = false }: IconProps) => {
  const inactiveColor = admin ? "#fff" : "#9da1b2"
  const activeColor = admin ? "#fff" : "#5694D8"
  return (
    <SvgIcon viewBox="0 0 15.003 19.406" fontSize="small">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.003"
        height="19.406"
        viewBox="0 0 15.003 19.406"
      >
        <path
          data-name="Path 5534"
          d="M3.302 12.15h11.06a.641.641 0 0 0 .641-.641V.64a.641.641 0 0 0-.641-.64H3.302a3.305 3.305 0 0 0-3.3 3.3v6.3a.641.641 0 1 0 1.281 0V3.3a2.024 2.024 0 0 1 2.021-2.021h10.417v9.587H3.302a3.3 3.3 0 0 0 0 6.6h1.641V19.4l2.67-1.2 2.669 1.2v-1.934h4.079a.641.641 0 1 0 0-1.281h-4.078v-1.38h4.079a.641.641 0 1 0 0-1.281H3.302a.641.641 0 1 0 0 1.281h1.641v1.38H3.302a2.021 2.021 0 1 1 0-4.041m5.7 2.661v2.616l-1.388-.622-1.388.622v-2.616Z"
          fill={active ? activeColor : inactiveColor}
        />
      </svg>
    </SvgIcon>
  )
}

export default DrawerSupplementalIcon
